import type {
  ILocationConfigItem,
  ISetupResponse,
} from '@booking-portal/types';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useAppStore = defineStore(
  'app',
  () => {
    const location = ref<ILocationConfigItem | undefined>();
    const setupData = ref<ISetupResponse>();

    function setLocation(newLocation: ILocationConfigItem | undefined) {
      location.value = newLocation;
    }

    return {
      location,
      setupData,
      appearance: computed(() => setupData.value?.appearance),
      tenant: computed(() => setupData.value?.tenant),
      isBlockedForMigration: computed(
        () => !!setupData.value?.isBlockedForMigration
      ),

      cookiePolicyUrl: computed(() => location.value?.privacyPolicyUrl),

      locationImprintUrl: computed(() => location.value?.imprintUrl),
      locationPrivacyPolicyUrl: computed(
        () => location.value?.privacyPolicyUrl
      ),

      globalImprintUrl: computed(() => setupData.value?.imprintUrl),
      globalPrivacyPolicyUrl: computed(() => setupData.value?.privacyPolicyUrl),
      setLocation,
    };
  },
  {
    persist: {
      // Avoid persisting custom JS so stale scripts do not execute on reload.
      // Also drop the migration flag so a stale banner does not flash before `/setup` resolves.
      omit: [
        'setupData.customJavascriptCode',
        'setupData.isBlockedForMigration',
      ],
    },
  }
);
